// extracted by mini-css-extract-plugin
export var item = "pagination-module--item--a3a51";
export var pager = "pagination-module--pager--0e71d";
export var selected = "pagination-module--selected--145bf";